/**
 * Injeta um input de pesquisa no menu do Tribute.js (.tribute-container).
 * Filtra os <li> por texto e evita que o menu feche/erre ao interagir com o input/scroll.
 */
export default {
  data() {
    return {
      tributeSearchObserver: null,
      tributeSearchLastQuery: "",
      tributeContainerMouseDownHandler: null,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initTributeSearch();
    });
  },
  beforeDestroy() {
    this.destroyTributeSearch();
  },
  methods: {
    initTributeSearch() {
      this.tributeSearchObserver = new MutationObserver(() => {
        this.ensureTributeSearchInput();
      });

      this.tributeSearchObserver.observe(document.body, {
        childList: true,
        subtree: true,
      });
    },
    destroyTributeSearch() {
      if (this.tributeSearchObserver) {
        this.tributeSearchObserver.disconnect();
        this.tributeSearchObserver = null;
      }

      const container = document.querySelector(".tribute-container");
      if (container && this.tributeContainerMouseDownHandler) {
        container.removeEventListener(
          "mousedown",
          this.tributeContainerMouseDownHandler
        );
        delete container.dataset.tributeSearchBound;
      }
      this.tributeContainerMouseDownHandler = null;
    },
    bindTributeContainerGuard(container) {
      if (container.dataset.tributeSearchBound === "1") {
        return;
      }

      // Tribute escuta mousedown no document. Se o alvo está no menu e não é <li>
      // (scroll, input de pesquisa, padding), ele lança erro.
      // Parar o bubble aqui evita o erro e mantém o menu aberto.
      this.tributeContainerMouseDownHandler = (event) => {
        if (!event.target.closest("li")) {
          event.stopPropagation();
        }
      };

      container.addEventListener("mousedown", this.tributeContainerMouseDownHandler);
      container.dataset.tributeSearchBound = "1";
    },
    ensureTributeSearchInput() {
      const container = document.querySelector(".tribute-container");
      if (!container || container.style.display === "none") {
        this.tributeSearchLastQuery = "";
        const existingInput = container
          ? container.querySelector(".tribute-search-input")
          : null;
        if (existingInput) {
          existingInput.value = "";
        }
        return;
      }

      this.bindTributeContainerGuard(container);

      const existingWrap = container.querySelector(".tribute-search-wrap");
      if (existingWrap) {
        this.filterTributeItems(container, this.tributeSearchLastQuery);
        return;
      }

      const wrap = document.createElement("div");
      wrap.className = "tribute-search-wrap";

      const input = document.createElement("input");
      input.type = "text";
      input.className = "form-control tribute-search-input";
      input.placeholder = "Pesquisar campo...";
      input.setAttribute("autocomplete", "off");

      input.addEventListener("keydown", (event) => {
        event.stopPropagation();

        if (event.key === "Escape") {
          input.value = "";
          this.tributeSearchLastQuery = "";
          this.filterTributeItems(container, "");
        }

        if (event.key === "ArrowDown" || event.key === "ArrowUp" || event.key === "Enter") {
          event.preventDefault();
        }
      });

      input.addEventListener("input", () => {
        this.tributeSearchLastQuery = input.value;
        this.filterTributeItems(container, input.value);
      });

      wrap.appendChild(input);
      container.insertBefore(wrap, container.firstChild);

      if (this.tributeSearchLastQuery) {
        input.value = this.tributeSearchLastQuery;
        this.filterTributeItems(container, this.tributeSearchLastQuery);
      }
    },
    filterTributeItems(container, query) {
      const normalized = (query || "").toLowerCase().trim();
      const items = container.querySelectorAll("ul li");

      items.forEach((item) => {
        const text = (item.textContent || "").toLowerCase();
        item.style.display = !normalized || text.includes(normalized) ? "" : "none";
      });
    },
  },
};
